import { create } from 'zustand';
import { sessionPaused, useSessionRecovery } from '@/stores/sessionRecovery';

// Cookie-rotation locks are per tab. Updating a lock must never persist an old
// profile over the confirmed clinic of another tab.
export const useSessionTransition = create<{ isSwitchingTenant: boolean }>(() => ({ isSwitchingTenant: false }));

export const sessionBlocked = () => sessionPaused() || useSessionTransition.getState().isSwitchingTenant;

export function useSessionBlocked() {
  const paused = useSessionRecovery((state) => state.phase !== 'idle');
  const switching = useSessionTransition((state) => state.isSwitchingTenant);
  return paused || switching;
}
